import TableList from ".";

export const tableRoutes = (data) => {
  return [
    {
      path: "/admin/table",
      title: "order",
      layout: "admin",
      routeType: "admin",
      component: TableList,
    },
  ];
};
